export var ApplicationActionType;
(function (ApplicationActionType) {
    ApplicationActionType["HardReset"] = "hardReset";
    ApplicationActionType["Reset"] = "reset";
    ApplicationActionType["ResetComplete"] = "resetComplete";
    ApplicationActionType["SoftReset"] = "softReset";
})(ApplicationActionType || (ApplicationActionType = {}));
export function hardResetApplication() {
    return { type: ApplicationActionType.HardReset };
}
export function resetApplication() {
    return { type: ApplicationActionType.Reset };
}
export function resetApplicationComplete() {
    return { type: ApplicationActionType.ResetComplete };
}
export function softResetApplication() {
    return { type: ApplicationActionType.SoftReset };
}
